import { post, get } from "shared-utils";
import { useLocalStorage } from "shared-ui";

import { MetricTypes } from "../autogen/metrics";
import { reportRequestFailure } from "./report-request-failure";

const DASHBOARD_CONFIGURATION_KEY = "wayflyer-insights-dashboard-configuration-data-";

export type PinnableMetric = { [key in MetricTypes]: boolean };

export interface DashboardConfigurationData {
  pinnable_metrics: PinnableMetric[];
}

export const initialDashboardConfiguration: DashboardConfigurationData = {
  pinnable_metrics: [],
};

const storeDashboardConfigurationDataInLocalStorage = (
  dashboardConfigurationPath,
  dashboardConfigurationData: DashboardConfigurationData
) => {
  window.localStorage.setItem(
    DASHBOARD_CONFIGURATION_KEY + dashboardConfigurationPath,
    JSON.stringify(dashboardConfigurationData)
  );
};

export function getDashboardConfigurationData(
  dashboardConfigurationPath: string,
  onSuccess: (data: DashboardConfigurationData) => any,
  onFailure: (failureMessage: string) => any
) {
  get(
    dashboardConfigurationPath,
    (data: DashboardConfigurationData) => {
      onSuccess(data);
    },
    (failureMessage: string, isNetworkFailure: boolean) => {
      reportRequestFailure("Error fetching dashboard configuration data", failureMessage, isNetworkFailure);
      onFailure(failureMessage);
    }
  );
}

export function storeDashboardConfigurationData(
  dashboardConfigurationPath: string,
  dashboardConfigurationData: DashboardConfigurationData,
  onSuccess: () => any,
  onFailure: (failureMessage: string) => any
) {
  post(
    dashboardConfigurationPath,
    {
      dashboardConfiguration: dashboardConfigurationData,
    },
    onSuccess,
    (failureMessage, isNetworkFailure) => {
      reportRequestFailure("Error updating dashboard configuration data", failureMessage, isNetworkFailure);
      onFailure(failureMessage);
    }
  );
  storeDashboardConfigurationDataInLocalStorage(dashboardConfigurationPath, dashboardConfigurationData);
}

export const useDashboardConfiguration = (dashboardConfigurationPath) => {
  return useLocalStorage(DASHBOARD_CONFIGURATION_KEY + dashboardConfigurationPath, initialDashboardConfiguration, true);
};
